
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
// import { formatJson } from "@/utils";
// import { exportJson2Excel } from "@/utils/excel";
import { cloneDeep } from "lodash";

@Component({
    name: "Search",
})
export default class searchContent extends Vue {
    @Prop({
        default: () => {
            return {};
        },
    })
    private optionsData!: object; // 初始化选项数据
    @Prop({}) private value!: object[]; // 搜索布局参数
    @Prop({}) private multipleSelection!: object[]; // 导出的列表数据
    @Prop({}) private filename!: string; // 导出的文件名
    @Prop({}) private selectionParams!: string[]; // 导出的文件格式头部
    @Prop({}) private filterVal!: string[]; // 导出的文件格式头部
    @Prop({ default: false }) private isShowExport!: boolean; // 是否显示导出按钮
    @Prop({ default: true }) private isShowBtn!: boolean; // 是否显示右侧按钮
    @Prop({ default: true }) private clearable!: boolean; // 是否可清除
    @Prop({ default: false }) private expand!: boolean; // 是否展示展开关闭按钮

    @Prop({ default: false }) private isShowAdd!: boolean; // 是否展示添加名称
    @Prop({ default: '添加' }) private ShowAddName!: string; // 添加名称
    @Prop({ default: 'el-icon-plus' }) private ShowAddIcon!: string; // 添加图标
    @Prop({ default: 'success' }) private ShowAddType!: string; // 添加样式
    @Prop({ default: false }) private isAllStatus!: boolean; // 添加样式
    @Prop({ default: false }) private isLoadOptions!: boolean; // 是否后加载表单
    @Prop({ default: 0 }) private show_length_number!: number; // 显示长度

    private downloadLoading: boolean = false;
    private originalData: any = [];
    private isLocked = true;
    private isAll: boolean = false;
    private show_length: number = 3;

    @Watch("isAllStatus")
    changeIsAllStatus(newVal: any) {
        this.isAll = newVal;
        this.expandDisplay();
    }
    @Watch("optionsData")
    changeSearchOptions(newVal: any) {
        try {
            for (let item of this.originalData) {
                Object.keys(newVal).forEach((key) => {
                    if (Array.isArray((item as any).filed)) {
                        if (
                            (item as any).filed[0] == key ||
                            (item as any).filed[1] == key
                        ) {
                            (item as any).selectOptions = newVal[key];
                            //console.log(newVal,key)
                            if(Array.isArray(item.values) && item.values[0]!=''){
                                item.values[0] = item.values[0];
                            }
                            else if(Array.isArray(item.values) && item.values[1]!=''){
                                item.values[1] = item.values[1];
                            }
                            else if (newVal[key].length > 0) {
                                item.values[0] = newVal[key][0].value;
                            }
                        }
                    } else {
                        if ((item as any).filed == key) {
                            (item as any).selectOptions = newVal[key];
                        }
                    }
                });
            }
        }
        catch(err){
            console.trace(err);
        }

        if (this.originalData.length > this.show_length && this.expand) {
            let arr: any[] = this.originalData.slice(0, this.show_length);
            this.$emit("input", cloneDeep(arr));
        } else {
            this.$emit("input", cloneDeep(this.originalData));
        }

        this.isLocked = false;
    }

    @Watch("value")
    changeValue(newVal: any) {
        if(this.isLoadOptions) this.originalData = cloneDeep(newVal);
    }
    created() {

        if((this.$slots.search)){
            this.show_length=4;
        }
        else{
            this.show_length=3;
        }
        if(this.show_length_number>0){
            this.show_length = this.show_length_number;
        }

        this.originalData = cloneDeep(this.value);
        if (this.originalData.length > this.show_length && this.expand) {
            /*
             * slice为浅拷贝
             */
            let arr: any[] = this.originalData.slice(0, this.show_length);

            this.$emit("input", cloneDeep(arr));
        }

        this.$nextTick(() => {
            this.isLocked = false;
        });

    }

    // 清空
    clear() {
        if (this.isLocked) return;

        if (this.originalData.length > this.show_length && this.expand) {
            if (this.isAll) {
                this.$emit("input", cloneDeep(this.originalData));
            } else {
                let arr: any[] = this.originalData.slice(0, this.show_length);

                this.$emit("input", cloneDeep(arr));
            }
        } else {
            this.$emit("input", cloneDeep(this.originalData));
        }

        let params: any = {};

        this.value.forEach((item: any) => {
            if (Array.isArray(item.filed)) {
                try {
                    if (
                        item.type == "select_date" &&
                        item.values[1] &&
                        item.values[1][0] &&
                        item.values[1][1]
                    ) {
                        params[item.filed[0]] = item.values[0];
                        params[item.filed[1]] = item.values[1][0];
                        params[item.filed[2]] = '';
                        return;
                    }

                    params[item.filed[0]] = item.values[0];
                    params[item.filed[1]] = '';
                } catch (err) {
                    console.log(err);
                }
            } else {
                params[item.filed] = '';
            }
        });


        this.$emit("clear",params);
    }

    expandDisplay() {
        if (this.isAll) {
            if (this.originalData.length > this.show_length && this.expand) {
                let arr: any[] = this.originalData.slice(0, this.show_length);
                this.$emit("input", cloneDeep(arr));
            }
        } else {
            let arr: any[] = cloneDeep(this.originalData);

            this.$emit("input", arr);
        }

        this.isAll = !this.isAll;
        this.$emit("isAllStatus", this.isAll);
    }

    selectChange(item: any){
        if(item.values[0] !== '' && item.values[1] !== '') {
            this.search();
        }
    }
    // 搜索操作
    search() {
        let params: any = {};

        this.value.forEach((item: any) => {
            if (Array.isArray(item.filed)) {
                try {
                    if (
                        item.type == "select_date" &&
                        item.values[1] &&
                        item.values[1][0] &&
                        item.values[1][1]
                    ) {
                        params[item.filed[0]] = item.values[0];
                        params[item.filed[1]] = item.values[1][0];
                        params[item.filed[2]] = item.values[1][1];
                        return;
                    }

                    params[item.filed[0]] = item.values[0];
                    params[item.filed[1]] = item.values[1];
                } catch (err) {
                    console.log(err);
                }
            } else {
                params[item.filed] = item.values;
            }
        });

        //console.log('this.value',this.value)
        this.$emit("search", params);
    }

    // 导出
    private handleDownload() {
        // if (this.multipleSelection && this.multipleSelection.length) {
        //     this.downloadLoading = true;
        //     const tHeader = this.selectionParams;
        //     const filterVal = this.filterVal;
        //     const list = this.multipleSelection;
        //     const data = formatJson(filterVal, list);
        //     exportJson2Excel(
        //         tHeader,
        //         data,
        //         this.filename !== "" ? this.filename : undefined
        //     );
        //     this.downloadLoading = false;
        // } else {
        //     this.$message({
        //         message: "请至少选择一项",
        //         type: "warning",
        //     });
        // }
    }
    private handle_add_func(val: any) {
        this.$emit("handle_add_func", val);
    }
}
